import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "../primitives/Reveal";
import { AccentTitle } from "../primitives/AccentTitle";

const EASE = [0.16, 1, 0.3, 1];

export const FAQ = () => {
    const { t } = useTranslation();
    const items = t("home.faq.items", { returnObjects: true }) || [];
    const [openIdx, setOpenIdx] = useState(0);

    return (
        <section id="faq" className="scroll-mt-24 bg-paper-grain py-24 lg:py-32" data-testid="faq-section">
            <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <Reveal className="lg:col-span-4">
                        <p className="eyebrow">{t("home.faq.kicker")}</p>
                        <AccentTitle
                            component="h2"
                            className="section-headline mt-5"
                            title={t("home.faq.title")}
                            accent={t("home.faq.titleAccent")}
                            accentColor="#8A1E12"
                        />
                        <p className="body-prose mt-6 max-w-md">
                            {/* small editorial filler from existing copy implied */}
                        </p>
                    </Reveal>

                    <div className="lg:col-span-8" data-testid="faq-accordion">
                        {items.map((it, i) => {
                            const open = openIdx === i;
                            return (
                                <div key={it.q || `faq-${i}`} className={`border-t-2 ${open ? "border-madder-500" : "border-ink-200"}`}>
                                    <button
                                        type="button"
                                        aria-expanded={open}
                                        onClick={() => setOpenIdx(open ? -1 : i)}
                                        data-testid={`faq-item-${i}`}
                                        className="flex min-h-[80px] w-full items-center justify-between gap-6 py-7 text-start hover:bg-mudbrick-100/40 px-2 transition-colors duration-200 rounded-[6px]"
                                    >
                                        <span className="font-display text-[22px] sm:text-[26px] font-bold leading-snug tracking-tight text-ink-800">
                                            {it.q}
                                        </span>
                                        <span
                                            className={`shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-[8px] transition-all duration-300 ease-nour ${open ? "bg-madder-500 text-white rotate-45" : "bg-mudbrick-200 text-ink-800"}`}
                                            aria-hidden="true"
                                        >
                                            <Plus className="h-5 w-5" strokeWidth={2.6} />
                                        </span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {open && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.32, ease: EASE }}
                                                style={{ overflow: "hidden" }}
                                            >
                                                <p className="body-prose max-w-[68ch] pb-8 ps-2">{it.a}</p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                        <div className="border-t-2 border-ink-200" />
                    </div>
                </div>
            </div>
        </section>
    );
};
